import {
  noWrap,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize
} from "@bps/fluent-ui";
import { useStores } from "@stores/hooks/useStores.ts";

interface ClaimTextBadgeProps {
  episodeOfCareId?: string;
}
export const ConditionTextBadge: React.FC<ClaimTextBadgeProps> = ({
  episodeOfCareId
}) => {
  const PRIVATETEXT = "Private";
  const { clinical } = useStores();

  const getClaimInfo = (episodeOfCareId?: string) => {
    if (episodeOfCareId) {
      const episodeOfCare = clinical.episodesOfCareMap.get(episodeOfCareId);

      if (episodeOfCare) {
        if (episodeOfCare.isPrivate) {
          return PRIVATETEXT;
        }

        const claim = episodeOfCare.claim;
        if (claim) {
          if (claim.claimNumber === undefined) return "Not lodged";
          return claim.claimNumber;
        }
      }
    }
    return undefined;
  };

  const claimText = getClaimInfo(episodeOfCareId);

  if (!claimText) return null;

  return (
    <TextBadge
      badgeSize={TextBadgeSize.small}
      horizontalAlign="center"
      badgeColor={
        claimText === PRIVATETEXT
          ? TextBadgeColor.lightGrey
          : TextBadgeColor.blue
      }
      styles={{
        root: {
          paddingLeft: "8px",
          paddingRight: "8px",
          ...noWrap
        }
      }}
    >
      {claimText}
    </TextBadge>
  );
};
